<template>
  <div class="contrato-page">
    <FondoDiagonal />
    <div class="contenido">
      <div class="contrato-wrapper">
        <!-- Header Section -->
        <div class="header-section">
          <div class="icon-container">
            <i class="fas fa-file-contract"></i>
          </div>
          <h1 class="main-title">Términos y Condiciones</h1>
          <p class="subtitle">Prestación de Servicios Educacionales</p>
        </div>

        <!-- Important Alert -->
        <div class="alert-important">
          <div class="alert-icon">
            <i class="fas fa-exclamation-circle"></i>
          </div>
          <div class="alert-content">
            <h3 class="alert-title">¡IMPORTANTE!</h3>
            <p class="alert-message">
              Deberás leer y aceptar los términos y condiciones de
              prestación de servicios educacionales para continuar
              con tu proceso de matrícula
            </p>
          </div>
        </div>

        <!-- PDF Viewer Section -->
        <div class="pdf-section">
          <div class="pdf-header">
            <i class="fas fa-file-pdf"></i>
            <span>Documento de Términos y Condiciones</span>
          </div>

          <div class="pdf-info">
            <i class="fas fa-info-circle"></i>
            <span>Si no puedes visualizar el documento, por favor recarga la página.</span>
          </div>

          <div class="pdf-container" ref="pdfContainer">
            <pdf
              class="pdf-page"
              v-for="i in numPages"
              :key="i"
              :src="src"
              :page="i"
            ></pdf>
          </div>
        </div>

        <!-- Acceptance Form -->
        <form @submit.prevent="siguiente" class="acceptance-form">
          <div class="checkbox-container">
            <input
              type="checkbox"
              id="contrato"
              v-model="aceptoContrato"
              class="custom-checkbox"
            >
            <label for="contrato" class="checkbox-label">
              <span class="checkbox-box">
                <i class="fas fa-check"></i>
              </span>
              <span class="checkbox-text">
                Acepto los términos y condiciones de prestación de servicios educacionales.
              </span>
            </label>
          </div>

          <!-- Error Message -->
          <div v-if="error" class="error-message">
            <i class="fas fa-exclamation-triangle"></i>
            <span>{{ error }}</span>
          </div>

          <!-- Action Buttons -->
          <div class="actions-container">
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="!aceptoContrato || cargando"
            >
              <span v-if="!cargando">
                <i class="fas fa-arrow-right"></i>
                Continuar con la matrícula
              </span>
              <span v-else>
                <i class="fas fa-spinner fa-spin"></i>
                Procesando...
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import FondoDiagonal from '@/componentes/UI/FondoDiagonal.vue';
import { aceptarContrato } from '@/assets/api/matricula';
import store from '@/store';
import pdf from 'vue-pdf';

const loadingTask = pdf.createLoadingTask('/documentos/TERMINOSYCONDICIONES2026.pdf');

export default {
  name: 'ContratoAntiguos',
  components: { pdf, FondoDiagonal },
  data() {
    return {
      src: loadingTask,
      numPages: undefined,
      aceptoContrato: false,
      cargando: false,
      error: '',
    };
  },
  beforeRouteEnter(to, from, next) {
    if (!store.state.sesion) {
      next({ name: 'login antiguos' });
    } else {
      next();
    }
  },
  async created() {
    const doc = await loadingTask.promise;
    this.numPages = doc.numPages;
  },
  methods: {
    async siguiente() {
      this.cargando = true;
      this.error = '';
      try {
        await aceptarContrato();
        store.commit('actualizaAceptaContrato', true);
        store.commit('actualizarEtapa', 1);
        await this.$router.push({ name: 'perfil estudiante' });
      } catch (e) {
        this.error = e.message || 'Ha ocurrido un error. Por favor intenta nuevamente.';
      } finally {
        this.cargando = false;
      }
    },
  },
};
</script>

<style scoped>
.contrato-page {
  position: relative;
  min-height: 100vh;
  padding: 2rem 0;
}

.contenido {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  padding: 2rem 1rem;
}

.contrato-wrapper {
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

/* Header Section */
.header-section {
  text-align: center;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  padding: 2.5rem 2rem;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  animation: fadeInDown 0.6s ease-out;
}

.icon-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, var(--azul-institucional), var(--celeste-institucional));
  border-radius: 50%;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 16px rgba(55, 82, 130, 0.3);
}

.icon-container i {
  font-size: 2.5rem;
  color: white;
}

.main-title {
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 700;
  color: var(--azul-institucional);
  margin: 0 0 0.5rem 0;
  letter-spacing: -0.5px;
}

.subtitle {
  font-size: clamp(1rem, 2vw, 1.25rem);
  color: var(--verde-institucional);
  font-weight: 500;
  margin: 0;
}

/* Alert Important */
.alert-important {
  display: flex;
  gap: 1.5rem;
  background: linear-gradient(135deg, #FFF5E6 0%, #FFE8CC 100%);
  border-left: 6px solid var(--naranjo);
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 16px rgba(242, 124, 8, 0.15);
  animation: fadeIn 0.6s ease-out 0.2s backwards;
}

.alert-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: var(--naranjo);
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(242, 124, 8, 0.3);
}

.alert-icon i {
  font-size: 2rem;
  color: white;
}

.alert-content {
  flex: 1;
}

.alert-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--naranjo);
  margin: 0 0 0.75rem 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.alert-message {
  font-size: 1.125rem;
  line-height: 1.6;
  color: #2C3E50;
  margin: 0;
}

/* PDF Section */
.pdf-section {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  animation: fadeInUp 0.6s ease-out 0.3s backwards;
}

.pdf-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, var(--azul-institucional), var(--celeste-institucional));
  color: white;
  border-radius: 10px;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 12px rgba(55, 82, 130, 0.3);
}

.pdf-header i {
  font-size: 1.5rem;
}

.pdf-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  background: linear-gradient(135deg, #E8F4FD, #D1E9F6);
  border-left: 4px solid var(--celeste-institucional);
  border-radius: 8px;
  color: var(--azul-institucional);
  font-size: 0.95rem;
  font-weight: 500;
  margin-bottom: 1.5rem;
}

.pdf-info i {
  font-size: 1.25rem;
  color: var(--celeste-institucional);
}

.pdf-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-height: 600px;
  overflow-y: auto;
  padding: 1rem;
  background: #F8F9FA;
  border-radius: 10px;

  /* Custom scrollbar */
  scrollbar-width: thin;
  scrollbar-color: var(--verde-institucional) #E0E0E0;
}

.pdf-container::-webkit-scrollbar {
  width: 10px;
}

.pdf-container::-webkit-scrollbar-track {
  background: #E0E0E0;
  border-radius: 5px;
}

.pdf-container::-webkit-scrollbar-thumb {
  background: var(--verde-institucional);
  border-radius: 5px;
  transition: background 0.3s ease;
}

.pdf-container::-webkit-scrollbar-thumb:hover {
  background: var(--azul-institucional);
}

.pdf-page {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.pdf-page:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

/* Acceptance Form */
.acceptance-form {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  animation: fadeInUp 0.6s ease-out 0.4s backwards;
}

/* Custom Checkbox */
.checkbox-container {
  margin-bottom: 2rem;
}

.custom-checkbox {
  display: none;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  cursor: pointer;
  user-select: none;
}

.checkbox-box {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 3px solid var(--verde-institucional);
  border-radius: 6px;
  background: white;
  transition: all 0.3s ease;
  margin-top: 2px;
}

.checkbox-box i {
  font-size: 1rem;
  color: white;
  opacity: 0;
  transform: scale(0);
  transition: all 0.3s ease;
}

.custom-checkbox:checked + .checkbox-label .checkbox-box {
  background: var(--verde-institucional);
  border-color: var(--verde-institucional);
  box-shadow: 0 4px 12px rgba(64, 185, 157, 0.4);
}

.custom-checkbox:checked + .checkbox-label .checkbox-box i {
  opacity: 1;
  transform: scale(1);
}

.checkbox-label:hover .checkbox-box {
  border-color: var(--azul-institucional);
  transform: scale(1.05);
}

.custom-checkbox:checked + .checkbox-label:hover .checkbox-box {
  background: var(--azul-institucional);
  border-color: var(--azul-institucional);
}

.checkbox-text {
  font-size: 1.125rem;
  line-height: 1.6;
  color: #2C3E50;
  font-weight: 500;
}

/* Error Message */
.error-message {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: linear-gradient(135deg, #FFE8E8, #FFD6D6);
  border-left: 4px solid var(--rojo-obstetricia);
  color: var(--rojo-obstetricia);
  padding: 1rem 1.25rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  font-weight: 500;
  animation: shake 0.5s ease-in-out;
}

.error-message i {
  font-size: 1.25rem;
}

/* Actions Container */
.actions-container {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 1rem 2.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-primary {
  background: linear-gradient(135deg, var(--verde-institucional), var(--celeste-institucional));
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: linear-gradient(135deg, var(--celeste-institucional), var(--azul-institucional));
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(55, 82, 130, 0.3);
}

.btn-primary:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(55, 82, 130, 0.2);
}

.btn:disabled {
  background: linear-gradient(135deg, #CCCCCC, #999999);
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}

.btn i {
  font-size: 1.25rem;
}

/* Animations */
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-10px); }
  75% { transform: translateX(10px); }
}

/* Responsive Design */
@media (max-width: 1024px) {
  .contrato-wrapper {
    max-width: 900px;
  }

  .pdf-container {
    max-height: 500px;
  }
}

@media (max-width: 768px) {
  .contrato-page {
    padding: 1rem 0;
  }

  .contenido {
    padding: 1rem 0.5rem;
  }

  .header-section {
    padding: 2rem 1.5rem;
  }

  .icon-container {
    width: 60px;
    height: 60px;
  }

  .icon-container i {
    font-size: 2rem;
  }

  .main-title {
    font-size: 2rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .alert-important {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 1.5rem;
    gap: 1rem;
  }

  .alert-icon {
    width: 50px;
    height: 50px;
  }

  .alert-icon i {
    font-size: 1.5rem;
  }

  .alert-title {
    font-size: 1.25rem;
  }

  .alert-message {
    font-size: 1rem;
  }

  .pdf-section {
    padding: 1.5rem;
  }

  .pdf-header {
    font-size: 1.125rem;
    padding: 1rem;
  }

  .pdf-container {
    max-height: 400px;
  }

  .acceptance-form {
    padding: 2rem 1.5rem;
  }

  .checkbox-text {
    font-size: 1rem;
  }

  .btn {
    padding: 0.875rem 2rem;
    font-size: 1rem;
    width: 100%;
  }

  .actions-container {
    justify-content: stretch;
  }
}

@media (max-width: 480px) {
  .header-section {
    padding: 1.5rem 1rem;
  }

  .alert-important {
    padding: 1.25rem;
  }

  .pdf-section {
    padding: 1rem;
  }

  .pdf-info {
    font-size: 0.875rem;
    padding: 0.875rem 1rem;
  }

  .acceptance-form {
    padding: 1.5rem 1rem;
  }

  .checkbox-box {
    width: 24px;
    height: 24px;
  }

  .checkbox-text {
    font-size: 0.9375rem;
  }

  .btn {
    padding: 0.75rem 1.5rem;
    font-size: 0.9375rem;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  * {
    animation: none !important;
    transition: none !important;
  }
}
</style>
